import { Loader2 } from 'lucide-react';

const ReferLoadingState = () => {
  return (
    <div className="py-12 flex flex-col items-center justify-center">
      <Loader2 className="animate-spin text-[#067978] mb-4" size={48} />
      <p className="text-slate-600 font-medium text-sm">Retrieving Agent details...</p>
    </div>
  );
};

export default ReferLoadingState;
